<div [ngClass]="['cerrix-title', size, clipText ? 'clip-text' : '']">
    @if (focus) {
        <input
            #input
            matInput
            [tabIndex]="0"
            [placeholder]="placeholder"
            class="edit-input"
            [(ngModel)]="value"
            [attr.data-uiid]="dataUiid + '-input'"
            (blur)="onInputBlur()"
            (input)="onInput($event)"
        />
    } @else {
        <div class="display-container">
            <div
                (click)="onEdit()"
                class="display-title"
                [class.required]="showAsRequired"
                [class.placeholder]="!value"
                [attr.data-uiid]="dataUiid + '-title'"
            >
                {{ value ? value : placeholder }}
            </div>
        </div>
    }
</div>
